module.exports = __webpack_public_path__ + "static/media/elk_clipboard_bg.dfd2e5a8.jpg";